module.exports = __webpack_public_path__ + "static/media/nattu-adnan-unsplash.c11f97a3.jpg";